export class AttributeType {
  constructor(public id: number, public name: string) {}
}
